exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adres-defteri-sec-card[data-v-7ab38c32]{border-radius:8px}.adres-defteri-toolbar-search[data-v-7ab38c32]{max-width:360px}.adres-defteri-table[data-v-7ab38c32]{border-top:1px solid #eee}", ""]);

// exports
